import React, { Fragment, useEffect, useContext, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";
import moment from "moment";
import Modal from "react-modal";
import ReactToPrint from "react-to-print";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

import { RegistrationReceipt } from "./main";
import Loading from "@component/UI/Loading";

export default () => {
    const navigate = useNavigate();
    const { site, iam } = useContext(AppContext);
    const [memos, setMemos] = useState([]);
    const [cert, setCert] = useState(null);
    const [speaker, setSpeaker] = useState(null);
    const [chariperson, setChariperson] = useState(null);
    const [registration, setRegistration] = useState(null);
    const [template, setTemplate] = useState(null);
    const [receipt, setReceipt] = useState(false);
    const [modal, setModal] = useState("");

    const loadCert = () => {
        _API.get({ path: "/site/mypage/cert" })
            .then((res) => {
                const { memos, cert, speaker, chariperson, registration, certTemplate, speakerTemplate, chairpersonTemplate } = res.data;
                setMemos(memos);
                setCert(cert);
                setSpeaker(speaker);
                setChariperson(chariperson);
                setRegistration(registration);
                setTemplate({
                    cert: certTemplate,
                    speaker: speakerTemplate,
                    chairperson: chairpersonTemplate,
                });
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => {
                    navigate("/");
                });
            });
    };

    useEffect(() => {
        if (site?.siteCode) {
            loadCert();
        }
    }, [site?.siteCode]);

    const getMemo = (type, field) => {
        let memo = memos.find((m) => m.type === type);

        if (!memo?.[field]) {
            return "";
        }
        if (field === "title") {
            return memo?.[field];
        } else {
            return <p dangerouslySetInnerHTML={{ __html: memo?.[field]?.replace(/\\/g, "") }}></p>;
        }
    };

    const getModal = () => {
        if (!template) {
            return "";
        }
        switch (modal) {
            case "CERT":
                return <Certification data={cert} template={template?.cert} onClose={() => setModal("")} />;
            case "SPEAKER":
                return <Certification data={speaker} template={template?.speaker} onClose={() => setModal("")} />;
            case "CHAIRPERSON":
                return <Certification data={chariperson} template={template?.chairperson} onClose={() => setModal("")} />;
        }
    };

    if (!_CK.isLogin()) {
        swal("Please Login first.").then(() => {
            document.location.href = "/";
        });

        return;
    }

    return (
        <Fragment>
            <div className="contents">
                {site?.naviMypageCert && parse(site?.naviMypageCert)}

                <div className="right">
                    <div className="contentsTop">
                        <h3>Certification</h3>
                        <div className="location">
                            <a href="/" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>Certification</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        {!cert && !speaker && !chariperson && registration?.payStatus !== "Y" ? (
                            <center>-</center>
                        ) : (
                            <div className="SuccessBox">
                                {cert && (
                                    <div className="btnArea1">
                                        <a href="" className="btn1 btnBlue1_cert" onClick={() => setModal("CERT")}>
                                            {getMemo("CERT", "title") || "Certification of Attendance"}
                                        </a>
                                    </div>
                                )}
                                {speaker && (
                                    <div className="btnArea1">
                                        <a href="" className="btn1 btnBlue1_cert" onClick={() => setModal("SPEAKER")}>
                                            {getMemo("SPEAKER", "title") || "Certification of Presenter"}
                                        </a>
                                    </div>
                                )}

                                {chariperson && (
                                    <div className="btnArea1">
                                        <a href="" className="btn1 btnBlue1_cert" onClick={() => setModal("CHAIRPERSON")}>
                                            {getMemo("CHAIRPERSON", "title") || "Certification of Chair"}
                                        </a>
                                    </div>
                                )}

                                {registration?.payStatus === "Y" && (
                                    <div className="btnArea1">
                                        <a href="" onClick={() => setReceipt(true)} className="btn1 btnBlue1_cert">
                                            {getMemo("RECEIPT", "title") || "Receipt"}
                                        </a>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {receipt && <RegistrationReceipt onClose={() => setReceipt(false)} />}

            {modal === "CERT" && <Certification data={cert} template={template?.cert} onClose={() => setModal("")} />}
            {modal === "SPEAKER" && <Certification data={speaker} template={template?.speaker} onClose={() => setModal("")} />}
            {modal === "CHAIRPERSON" && <Certification data={chariperson} template={template?.chairperson} onClose={() => setModal("")} />}
        </Fragment>
    );
};

const Certification = (props) => {
    const { data, template } = props;
    const { site, iam } = useContext(AppContext);
    const [content, setContent] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const printRef = useRef(null);

    const modalStyles = {
        overlay: {
            zIndex: "1001",
        },
        content: {
            top: "50%",
            left: "50%",
            right: "40%",
            bottom: "-45%",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            overflowY: "auto",
        },
    };

    useEffect(() => {
        if (template) {
            const tmp = JSON.parse(JSON.stringify(template));
            let content = tmp.content;

            let coAuthor = data?.coAuthor;
            coAuthor = data?.coAuthor?.split("|");
            if (coAuthor && coAuthor?.length > 0) {
                coAuthor = coAuthor?.join("<br/>");
            } else {
                coAuthor = "";
            }

            content = content.replace("__NAME_ENG__", data?.nameEng || "");
            content = content.replace("__COUNTRY__", data?.country || "");
            content = content.replace("__COMPANY__", data?.company || "");
            content = content.replace("__LICENSE_NUMBER__", data?.licenseNumber || "");
            content = content.replace("__TITLE__", data?.title || "");
            content = content.replace("__SESSION_NO__", data?.sessionNo || "");
            content = content.replace("__SESSION_THEME__", data?.sessionTheme || "");
            content = content.replace("__CO_AUTHOR__", coAuthor || "");

            tmp.content = content;

            setContent(tmp);

            setTimeout(() => {
                setIsLoading(false);
            }, 100);
        }
    }, [template]);

    return (
        <Modal isOpen={true} onRequestClose={props.onClose} style={modalStyles} contentLabel="Certification">
            {isLoading && <Loading />}
            <div dangerouslySetInnerHTML={{ __html: content?.content }} ref={printRef}></div>
            <div className="btnArea1">
                <button className="btn1 btnGray1 mr2" onClick={props.onClose}>
                    Close
                </button>
                <ReactToPrint trigger={() => <button className="btn1 btnBlue1">Print</button>} content={() => printRef.current} />
            </div>
        </Modal>
    );
};
